module.exports = __webpack_public_path__ + "40d145dd8c976fd86ba7cf99e2de5f67.svg";